(function () {
  'use strict';

  var nextPageUrl = null;
  var isLoading = false;
  var scrollObserver = null;
  var mutationObs = null;
  var sentinel = null;
  var lastKnownCount = 0;

  function grid() {
    return document.querySelector('.boost-pfs-filter-products');
  }

  function paginationEl() {
    return document.querySelector('.boost-pfs-filter-bottom-pagination');
  }

  function getNextUrl() {
    var pag = paginationEl();
    if (!pag) return null;
    var a = pag.querySelector('.next a');
    return a ? a.href : null;
  }

  function hidePagination() {
    var pag = paginationEl();
    if (pag) pag.style.display = 'none';
  }

  function createSentinel() {
    if (sentinel) sentinel.remove();
    sentinel = document.createElement('div');
    sentinel.id = 'ellatino-infinite-sentinel';
    sentinel.style.cssText = 'height:1px;clear:both;width:100%;';
    var g = grid();
    if (!g) return;
    var pag = paginationEl();
    if (pag && pag.parentElement === g.parentElement) {
      g.parentElement.insertBefore(sentinel, pag);
    } else {
      g.insertAdjacentElement('afterend', sentinel);
    }
  }

  function createLoader() {
    var el = document.getElementById('ellatino-infinite-loader');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'ellatino-infinite-loader';
    el.style.cssText = [
      'text-align:center',
      'padding:30px 0',
      'width:100%',
      'font-size:13px',
      'letter-spacing:0.12em',
      'text-transform:uppercase',
      'color:#888',
      'clear:both'
    ].join(';');
    el.innerHTML = '<span>Loading…</span>';
    if (sentinel && sentinel.parentElement) {
      sentinel.parentElement.insertBefore(el, sentinel);
    }
    return el;
  }

  function removeLoader() {
    var el = document.getElementById('ellatino-infinite-loader');
    if (el) el.remove();
  }

  function loadNextPage() {
    if (isLoading || !nextPageUrl) return;
    isLoading = true;
    createLoader();

    fetch(nextPageUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newItems = doc.querySelectorAll('.boost-pfs-filter-products > .grid__item');
        var g = grid();

        if (newItems.length > 0 && g) {
          newItems.forEach(function (item) {
            item.classList.remove('aos-animate');
            g.appendChild(item.cloneNode(true));
          });
          lastKnownCount = g.children.length;

          if (window.AOS) window.AOS.refresh();

          if (window._swat && typeof window._swat.evtLayer === 'object') {
            try { window._swat.evtLayer.triggerEvent('wishlistWidgetsRender', {}); } catch (e) {}
          }
        }

        var newNextLink = doc.querySelector('.boost-pfs-filter-bottom-pagination .next a');
        nextPageUrl = newNextLink ? newNextLink.href : null;

        if (!nextPageUrl) {
          if (scrollObserver) scrollObserver.disconnect();
          if (sentinel) { sentinel.remove(); sentinel = null; }
        }
      })
      .catch(function (err) {
        console.warn('[Ellatino Infinite Scroll] Error:', err);
      })
      .finally(function () {
        isLoading = false;
        removeLoader();
      });
  }

  function initInfiniteScroll() {
    var g = grid();
    if (!g) return;

    lastKnownCount = g.children.length;
    nextPageUrl = getNextUrl();

    if (!nextPageUrl) return;

    hidePagination();
    createSentinel();

    if (scrollObserver) scrollObserver.disconnect();

    scrollObserver = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !isLoading) {
        loadNextPage();
      }
    }, { rootMargin: '400px 0px' });

    if (sentinel) scrollObserver.observe(sentinel);
  }

  function watchBoostRerender() {
    var section = document.getElementById('CollectionSection');
    if (!section) return;

    if (mutationObs) mutationObs.disconnect();

    var debounceTimer = null;

    mutationObs = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return m.type === 'childList' && (
          m.target.id === 'CollectionSection' ||
          (m.target.classList && m.target.classList.contains('boost-pfs-filter-products'))
        );
      });

      if (!relevant) return;

      var g = grid();
      var currentCount = g ? g.children.length : 0;
      if (currentCount >= lastKnownCount) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (scrollObserver) { scrollObserver.disconnect(); scrollObserver = null; }
        if (sentinel) { sentinel.remove(); sentinel = null; }
        isLoading = false;
        initInfiniteScroll();
      }, 200);
    });

    mutationObs.observe(section, { childList: true, subtree: true });
  }

  function init() {
    initInfiniteScroll();
    watchBoostRerender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 600);
  }

})();